import { getFromReduxStorage } from '../storage/reduxStorage';

export const getLocaleLanguage = () => getFromReduxStorage('intl.locale', 'EN');
